import { put } from 'redux-saga/effects'
import { removeUser, removeUserFailed, removeUserSuccess } from '../actions'
import { enterpriseRemoveUsers } from '../../../utils/api'

export function* removeUserHandler(data) {
  try {
    removeUser(data)
    const response = yield enterpriseRemoveUsers({
      accounts: data,
    })
    yield put(removeUserSuccess(response.data))
  } catch (error) {
    yield put(removeUserFailed(error))
  }
}
